module.exports = __webpack_public_path__ + "static/img/bank.c2e1093f.png";